"use client";

import { m as motion } from "framer-motion";
import { Image } from "@/components/ui/image";
import { fadeInUp, fadeInScale, defaultViewport, defaultTransition, fastTransition } from "@/lib/motion";
import { EXTERNAL_LINKS } from "../lib/constants";

export const AlumniCompaniesSection = () => {
  const companies = [
    {
      name: "Google",
      logo: "/images/logo_google.webp",
      url: "https://google.com",
      alt: "Google company logo",
    },
    {
      name: "Duracell",
      logo: "/images/logo_duracell.webp",
      url: "https://duracell.com",
      alt: "Duracell company logo",
    },
    {
      name: "Toyota Connected",
      logo: "/images/logo_toyota_connected.webp",
      url: "https://toyotaconnected.com",
      alt: "Toyota Connected company logo",
    },
    {
      name: "Eaglestone Inc",
      logo: "/images/logo_eaglestone.webp",
      url: "https://eaglestoneinc.com",
      alt: "Eaglestone Inc company logo",
    },
    {
      name: "Waymo",
      logo: "/images/logo_waymo.webp",
      url: "https://waymo.com",
      alt: "Waymo company logo",
    },
  ];

  return (
    <section className="container-class relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-mesh opacity-20 pointer-events-none" />
      
      <div className="section-inner relative z-10">
        <motion.div
          initial={fadeInUp.initial}
          whileInView={fadeInUp.animate}
          viewport={defaultViewport}
          transition={defaultTransition}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background mb-4">
            AI for HR Mastermind Community
          </h2>

        </motion.div>
        
        <motion.div
          initial={fadeInScale.initial}
          whileInView={fadeInScale.animate}
          viewport={defaultViewport}
          transition={{ ...defaultTransition, delay: 0.2 }}
          className="mb-12"
        >
          <Image 
            src="/images/group-shot-2.webp" 
            width={800} 
            height={600} 
            alt="AI for HR Mastermind Community members" 
            className="mx-auto overflow-hidden rounded-xl object-cover object-center w-full max-w-[800px]" 
          />
        </motion.div>
        <p className="text-lg md:text-xl text-background/80 max-w-2xl mx-auto mb-12 text-center">
            Our premium members are from:
          </p>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 items-center">
          
          {companies.map((company, index) => (
            <motion.a
              key={company.name}
              href={company.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={fadeInScale.initial}
              whileInView={fadeInScale.animate}
              viewport={defaultViewport}
              transition={{ ...fastTransition, delay: index * 0.08 }}
              className="glass-card p-6 hover-lift hover:shadow-depth-xl flex items-center justify-center"
            >
              <Image
                src={company.logo}
                alt={company.alt}
                width={130}
                height={50}
                className="object-contain filter grayscale hover:grayscale-0 transition-all duration-300 mx-auto"
              />
            </motion.a>
          ))}
        </div>
        
        <motion.div
          initial={fadeInUp.initial}
          whileInView={fadeInUp.animate}
          viewport={defaultViewport}
          transition={{ ...defaultTransition, delay: 0.5 }}
          className="mt-12 text-center"
        >
          <a
            href={EXTERNAL_LINKS.PREMIUM_MASTERMIND_APPLICATION}
            className="inline-flex items-center px-8 py-4 text-lg font-semibold rounded-2xl bg-primary text-primary-foreground shadow-primary hover:shadow-glow-primary hover:-translate-y-1 transition-all duration-300"
          >
            Apply to Join Them
          </a>
        </motion.div>
      </div>
    </section>
  );
};
